import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationAccessRightCategoryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccessRightCategory/AccessRightCategoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationAccessRightCategory"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationAccessRightCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationAccessRightCategoryActivity)
